/* eslint-disable react/no-unused-prop-types */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';

import { mediaPhone } from '../styles/breakpoints';
import { LogoLabelStyles, px, LOGO_PHONE_SCALE } from '../styles/Logo';
import { sharpImageRendering } from '../styles/images';

import LogoImage from './DPLLogo-248x165.png';

const LOGO_WIDTH = 83;
const LOGO_HEIGHT = 55;

export const DPLLogoSmallOnPhone = css({
  [mediaPhone]: {
    width: px(LOGO_WIDTH * LOGO_PHONE_SCALE),
    height: px(LOGO_HEIGHT * LOGO_PHONE_SCALE),
    marginTop: '6px',
  },
});

class DPLLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  render() {
    const { className, labelStyles, imageContainerStyles, imageStyles } = this.props;
    const { loaded } = this.state;
    return (
      <article className={className}>
        <div className={css(LogoLabelStyles, labelStyles)}>
          Gefördert von
        </div>
        <div
          className={css({
            textAlign: 'right',
          }, imageContainerStyles)}
        >
          <a href="https://www.postcode-lotterie.de" target="_blank" rel="noopener nofollow external">
            <img
              src={LogoImage}
              alt="Deutsche Postcode Lotterie"
              className={css(sharpImageRendering, {
                width: px(LOGO_WIDTH),
                height: px(LOGO_HEIGHT),
                marginTop: '2px',
                transition: 'opacity 0.25 ease-in-out',
              }, imageStyles)}
              style={{ opacity: loaded ? 1 : 0 }}
              onLoad={() => this.setState({ loaded: true })}
            />
          </a>
        </div>
      </article>
    );
  }
}

DPLLogo.propTypes = {
  className: PropTypes.string,
  labelStyles: PropTypes.any,
  imageContainerStyles: PropTypes.any,
  imageStyles: PropTypes.any,
};

DPLLogo.defaultProps = {
  className: undefined,
  labelStyles: undefined,
  imageContainerStyles: undefined,
  imageStyles: undefined,
};

export default DPLLogo;



// WEBPACK FOOTER //
// ./src/components/DPLLogo/DPLLogo.js